<ng-select
	appendTo="body"
	bindLabel="label"
	bindValue="value"
	[clearable]="clearable()"
	[formControl]="control"
	[items]="options"
	[placeholder]="placeholder()"
/>
